import {post} from '../Services/http';
import { catchError } from './Error.action';
import { show as showNotification } from './Notification.action';


export const BULKINSERT_RECEIVE = 'BULKINSERT_RECEIVE';
export const BULKINSERT_ERROR = 'BULKINSERT_ERROR';


export const bulkinsert = ({productlistarr,nodeIdToShowNotification = null, notificationMessage = null, hash = ''}) => {
    return (dispatch) => {
        return post('/api/cart/bulkinsert', { Productlist: productlistarr })
            .then(response => response.json())
            .then(result => {
             
                dispatch(receive(result));
                if(result.isSuccess){
                  nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                }
            })
            .catch(ex => dispatch(catchError(ex, error => setError(error))));
    }
}

const receive = (result) => (
    {
    type: BULKINSERT_RECEIVE,
    payload: {
        result,
    },
})
export const setError = error => ({
    type: BULKINSERT_ERROR,
    payload: {
        error,
    },
})


